
import { useState, useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { PinForm } from "@/components/pins/PinForm";
import { usePinCreation } from "@/hooks/use-pin-creation";

export default function CreatePin() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState<string | null>(null);
  const { isLoading, createPin } = usePinCreation();

  // Get the current user ID
  useEffect(() => {
    const getUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user?.id) {
        setUserId(session.user.id);
      } else {
        toast("Você precisa estar logado para criar um pin.");
        navigate("/auth");
      }
    };
    
    getUser();
  }, [navigate]);

  const handleFormSubmit = async (formData: any) => {
    await createPin(formData, userId);
  };

  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="container mx-auto px-4 pt-24 pb-16 max-w-2xl">
        <Button
          variant="ghost"
          className="mb-6"
          onClick={() => navigate("/create")}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>

        <h1 className="text-2xl font-bold mb-8">Criar novo Ink Pin</h1>

        <PinForm 
          userId={userId} 
          onSubmit={handleFormSubmit} 
          isLoading={isLoading} 
        />
      </main>
    </div>
  );
}
